import { useEffect, useState, useCallback } from 'react';
import { getApiUrl } from '../config';
import type { H2HResponse } from '../types/headToHead';

const authHeaders = (): HeadersInit => {
  const token = localStorage.getItem('authToken');
  return {
    'Content-Type': 'application/json',
    ...(token && { Authorization: `Bearer ${token}` }),
  };
};

interface Params {
  groupId: string;
  userA: string;
  userB: string;
  seasonId?: string | null;
}

export function useHeadToHead({ groupId, userA, userB, seasonId }: Params) {
  const [data, setData] = useState<H2HResponse | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const refresh = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const qs = new URLSearchParams({ userA, userB });
      if (seasonId) qs.set('seasonId', seasonId);
      const res = await fetch(getApiUrl(`/groups/${groupId}/head-to-head?${qs.toString()}`), {
        headers: authHeaders(),
      });
      if (!res.ok) throw new Error(`http ${res.status}`);
      const json = await res.json();
      setData(json);
    } catch (err: any) {
      setError(err?.message || 'fetch failed');
      setData(null);
    } finally {
      setLoading(false);
    }
  }, [groupId, userA, userB, seasonId]);

  useEffect(() => { refresh(); }, [refresh]);

  return { data, loading, error, refresh };
}
